import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const services = [
    'Microsoft 365 & Power Platform',
    'Web Development',
    'Database Management',
    'Mobile App Development',
    'API Development',
    'Digital Modernisation',
    'Process Automation & AI',
    'Testing & QA',
  ];

  const company = [
    { label: 'About Us', path: '/about' },
    { label: 'Services', path: '/services' },
    { label: 'Why Choose Us', path: '/why-us' },
    { label: 'Engagement Models', path: '/engagement' },
    { label: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="footer">
      <div className="footer-glow" />
      <div className="container">
        <div className="footer-top">
          {/* Brand column */}
          <div className="footer-brand">
            <img src="/companylogo1.png" alt="CoreNuVate IT" className="footer-logo" />
            <p className="footer-tagline">
              Empowering enterprises through modern IT solutions — cloud, automation, and intelligent software.
            </p>
            <div className="footer-contact-list">
              <a href="mailto:support@corenuvate.com" className="footer-contact-item">
                <FaEnvelope /> support@corenuvate.com
              </a>
              <a href="tel:+31627877227" className="footer-contact-item">
                <FaPhone /> +31 627 877 227
              </a>
              <span className="footer-contact-item">
                <FaMapMarkerAlt /> Ary Meuldijkstraat 6, 3151 JC Hoek van Holland
              </span>
            </div>
            <div className="footer-socials">
              <a href="https://linkedin.com/company/corenuvate" target="_blank" rel="noopener noreferrer" className="social-btn">
                <FaLinkedin />
              </a>
              <a href="mailto:support@corenuvate.com" className="social-btn">
                <FaEnvelope />
              </a>
            </div>
          </div>

          {/* Services column */}
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              {services.map(s => (
                <li key={s}>
                  <Link to="/services"><FaArrowRight className="link-arrow" />{s}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company column */}
          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              {company.map(c => (
                <li key={c.path}>
                  <Link to={c.path}><FaArrowRight className="link-arrow" />{c.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA column */}
          <div className="footer-col footer-cta-col">
            <h4>Ready to Transform?</h4>
            <p>Let's discuss your project and build something great together.</p>
            <button className="footer-cta-btn" onClick={() => navigate('/contact')}>
              Get in Touch <FaArrowRight />
            </button>
            <div className="footer-legal">
              <span>KvK: 99600293</span>
              <span>BTW: NL005397952B82</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} CoreNuVate IT. All rights reserved.</p>
          <p className="text-muted" style={{ fontSize: '0.8rem' }}>
            Netherlands · Enterprise IT Solutions
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;